import { Box, Typography, duration, useMediaQuery } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import SmallCheckIcon from '../../../kit/icons/SmallCheckIcon';
import Section from '../../../shared/Section/Section';

function PrecourseWhatYouGet({ title, details, images, image, durationImg }) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Section
      withoutBg
      customStyles={{
        paddingTop: {
          xs: 0,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          padding: {
            md: '40px 0px 40px 30px',
            xs: '24px 16px 32px 16px',
          },
          backgroundColor: 'kit.background.lightpurple',
          borderRadius: '40px',
          flexDirection: {
            md: 'row',
            xs: 'column',
          },
        }}
      >
        <Box sx={{}}>
          <Typography
            variant={isSm ? 'mobileH3' : 'desktopH3'}
            color={'kit.text.main'}
            mb={{
              md: '32px',
              xs: '23px',
            }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: {
                md: '24px',
                xs: '12px',
              },
              mb: {
                md: '40px',
                xs: '24px',
              },
            }}
          >
            {details.map((detail) => (
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                }}
                key={detail}
              >
                <SmallCheckIcon />
                <Typography variant={isSm ? 'mobileP2' : 'desktopP2'}>
                  {detail}
                </Typography>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              display: {
                md: 'flex',
              },
            }}
          >
            <Box
              sx={{
                flex: {
                  md: 0.8,
                },
                minWidth: {
                  md: '562px',
                },
                minHeight: {
                  md: '132px',
                },
              }}
            >
              <GatsbyImage
                image={
                  isSm
                    ? getImage(images[`howBootcampWorks/${durationImg}Mobile`])
                    : getImage(images[`howBootcampWorks/${durationImg}`])
                }
                alt="img"
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: {
              lg: 'flex',
              md: 'none',
              xs: 'none',
            },
            width: {
              md: '606px',
            },
            height: {
              md: '352px',
            },
            alignSelf: 'center',
          }}
        >
          <Box
            sx={{
              width: {
                md: '606px',
              },
              height: {
                md: '352px',
              },
            }}
          >
            <GatsbyImage
              image={getImage(images[`howBootcampWorks/${image}`])}
              alt="img"
            />
          </Box>
        </Box>
      </Box>
    </Section>
  );
}

export default PrecourseWhatYouGet;
